import BaseApi from './BaseApi'

export default class StreamingApi extends BaseApi {
    async requestLive (hardwareId, quality, channels) {
        return await this.post(`/api/v1.0/streaming/live`, {
            hardwareId,
            quality,
            channels,
        })
    }
    async stopLive (hardwareId) {
        return await this.post(`/api/v1.0/streaming/live/stop`, {
            hardwareId,
        })
    }
    async requestPlayback (hardwareId, quality, channels, startTime, endTime) {
        return await this.post(`/api/v1.0/streaming/remotePlayback`, {
            hardwareId,
            quality,
            channels,
            startTime,
            endTime
        })
    }
    async stopPlayback (hardwareId) {
        return await this.post(`/api/v1.0/streaming/remotePlayback/stop`, {
            hardwareId,
        })
    }
    async requestCalendar (hardwareId, quality) {
        return await this.get(`/api/v1.0/streaming/calendar`, {
            hardwareId,
            quality
        })
    }
    async requestFiles (hardwareId, quality, channels, day) {
        return await this.get(`/api/v1.0/streaming/files`, {
            hardwareId,
            quality,
            channels,
            day
        })
    }
}
